import { FC, memo } from 'react';
import { useRouter } from 'next/router';

import { Videos } from '@keaze/web/components/videos';
import { VideosSection as UIVideosSection } from './videosSection.styles';
import { Specifications } from '../specifications';
import { OnPlanClick } from '../planModal';
import { onQueryDialogClick } from '@keaze/web/utils/queryDialog';
import { QueryModals } from '@keaze/web/common/enums';
import { VideosSectionProps } from './videosSection.types';

export const VideosSection: FC<VideosSectionProps> = memo(
  ({ listing, description, videos, specifications = [], onVideoClick }) => {
    const router = useRouter();
    const customVideos = videos === null ? [] : videos;
    const isVisibleSpecifications =
      specifications !== null && specifications.length !== 0;

    if (customVideos.length === 0 && !isVisibleSpecifications) {
      return null;
    }

    const handleSpecificationClick: OnPlanClick = (id) => {
      onQueryDialogClick({ router, name: QueryModals.plan, value: id });
    };

    return (
      <UIVideosSection container>
        <Videos
          title={listing.name}
          listing={listing}
          description={description}
          videos={customVideos}
          onChange={onVideoClick}
        />
        {isVisibleSpecifications && (
          <Specifications
            data={specifications}
            onClick={handleSpecificationClick}
          />
        )}
      </UIVideosSection>
    );
  }
);
